import { createSelector } from '@ngrx/store';
import { IAppState } from 'app/IAppState';

const uploadBexFileSelectors = (state: IAppState) => state.deployment.uploadBexFile;

export const getCurrentBexFile = createSelector(
    uploadBexFileSelectors,
    (state: IUploadBexFileState) => state.currentBex
);

export const getHistory = createSelector(
    uploadBexFileSelectors,
    (state: IUploadBexFileState) => state.historyBex
);

export const getBexTraces = createSelector(
    uploadBexFileSelectors,
    (state: IUploadBexFileState) => state.bexFileTraces
);

export const getIsLoadingTraces = createSelector(
  uploadBexFileSelectors,
  (state: IUploadBexFileState) => state.isLoadingTraces
);

export const getBexFromServer = createSelector(
    uploadBexFileSelectors,
    (state: IUploadBexFileState) => state.currentBexOnServer
);

export const isLoadingUpload = createSelector(
    uploadBexFileSelectors,
    (state: IUploadBexFileState) => state.isLoading
);

export const getStatus = createSelector(
    uploadBexFileSelectors,
    (state: IUploadBexFileState) => state.status
);

export const getStatusApply = createSelector(
  uploadBexFileSelectors,
  (state: IUploadBexFileState) => state.applyStatus
);

export const isLoadingHistory = createSelector(
    uploadBexFileSelectors,
    (state: IUploadBexFileState) => state.isLoadingHistory
);

export const isLoadingTraces = createSelector(
    uploadBexFileSelectors,
    (state: IUploadBexFileState) => state.isLoadingTraces
);

export const canReload = createSelector(
    uploadBexFileSelectors,
    (state: IUploadBexFileState) => state.canReload
);

export const getMaintenanceReasons = createSelector(
    uploadBexFileSelectors,
    (state: IUploadBexFileState) => state.maintenanceReasons
);

export const getApplyStatus = createSelector(
    uploadBexFileSelectors,
    (state: IUploadBexFileState) => state.applyStatus
);
